function toFiniteNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function formatCoordinatePair(lat, lng) {
  const safeLat = toFiniteNumber(lat);
  const safeLng = toFiniteNumber(lng);
  if (safeLat === null || safeLng === null) return "";
  return `${safeLat},${safeLng}`;
}

export function getDeviceNavigationUrl({ address, lat, lng, userAgent } = {}) {
  const trimmedAddress = String(address || "").trim();
  const coordinates = formatCoordinatePair(lat, lng);
  if (!trimmedAddress && !coordinates) return "";

  const ua = String(userAgent || "");

  if (/Android/i.test(ua)) {
    const query = trimmedAddress || coordinates;
    const geoBase = coordinates || "0,0";
    return `geo:${geoBase}?q=${encodeURIComponent(query)}`;
  }

  if (/iPhone|iPad|iPod/i.test(ua)) {
    const destination = trimmedAddress || coordinates;
    return `http://maps.apple.com/?daddr=${encodeURIComponent(destination)}&dirflg=d`;
  }

  const destination = encodeURIComponent(trimmedAddress || coordinates);
  return `https://www.google.com/maps/dir/?api=1&destination=${destination}&travelmode=driving`;
}
